"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Generic = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const generic_style_1 = __importDefault(require("./generic.style"));
const invisible_1 = require("../../invisible");
const Generic = ({ classes, className, type, onClick, label, buttonRef, disabled, children, ...props }) => {
    const rootProps = {
        ...props,
        onClick: () => !disabled && onClick(),
        type,
        className: `${classes.root} ${className}`,
        disabled,
        ref: buttonRef
    };
    return (jsx_runtime_1.jsxs("button", Object.assign({}, rootProps, { children: [jsx_runtime_1.jsx(invisible_1.Invisible, { children: label }, void 0), children] }), void 0));
};
exports.Generic = Generic;
exports.Generic.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    className: prop_types_1.default.string,
    variant: prop_types_1.default.string,
    color: prop_types_1.default.string,
    size: prop_types_1.default.string,
    type: prop_types_1.default.string,
    onClick: prop_types_1.default.func.isRequired,
    label: prop_types_1.default.string.isRequired,
    buttonRef: prop_types_1.default.func,
    disabled: prop_types_1.default.bool,
    children: prop_types_1.default.node.isRequired
};
exports.Generic.defaultProps = {
    className: '',
    type: 'button',
    variant: 'none',
    color: 'indigo3',
    size: '21px',
    disabled: false,
    buttonRef: null
};
exports.default = react_jss_1.default(generic_style_1.default)(exports.Generic);
//# sourceMappingURL=index.js.map